import { useState, useContext } from 'react'
import { MyContext } from '../../App'
import { Row, Col, Button, Form, Input, message } from "antd"
import { TiFlashOutline } from "react-icons/ti"
import { get } from "../../libs/helper"


export function Login() {

      const { AppData, setAppData, setUserData } = useContext(MyContext)
      const [loading, setLoading] = useState(false)
      const [btnText, setBtnText] = useState('Sign in')
      const [forgotMode, setForgotMode] = useState(false)

      async function onFinish(values) {

            setLoading(true)
            setBtnText('Please wait')

            try {

                  const response = await fetch(`${AppData.api.base}/auth/login`, {
                        method: "POST",
                        headers: {
                              "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                              username: values.email,
                              password: values.password
                        })
                  })

                  const data = await response.json()

                  if (data.status === "success" && data.result) {

                        const user = data.result

                        // Get rest of users for lookups
                        const params = {
                              brand: "dasher",
                              table: "users",
                              query: {
                                    select: `id,first_name, last_name`
                              }
                        }

                        const { result: users } = await get(params, AppData)

                        // Get other config info
                        const query = {
                              brand: "dasher",
                              table: "config",
                              query: {
                                    select: `acturis_maint_window_start, acturis_maint_window_end`
                              }
                        }

                        const { result: config } = await get(query, AppData)

                        setAppData({ users: users, config: config[0] })

                        setUserData({ ...user, loggedIn: true })

                  } else {
                        message.error("Invalid email or password.")
                        setLoading(false)
                        setBtnText('Sign in')
                  }

            } catch (err) {

                  console.log(err)
                  message.error("Something went wrong. Please try again.")
                  setLoading(false)
                  setBtnText('Sign in')

            }

      }

      async function onForgotFinish(values) {

            setLoading(true)

            try {

                  await fetch(`${AppData.api.base}/auth/forgot-password`, {
                        method: "POST",
                        headers: {
                              "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                              username: values.email
                        })
                  })

                  message.success("If that email exists, we've sent a reset link.")
                  setForgotMode(false)

            } catch (err) {

                  console.log(err)
                  message.error("Something went wrong. Please try again.")

            }

            setLoading(false)

      }

      const onFinishFailed = (errorInfo) => {
            console.log('Failed:', errorInfo)
            message.error('The form contains an error. Please fix it!')
      }


      return (
            <>
                  <Row justify="center">
                        <Col xs={22} md={8} style={{ textAlign: 'center' }}>
                              <TiFlashOutline style={{ color: '#E41882', fontSize: '90px', marginTop: '100px' }} />
                              <Row justify="center" style={{ marginTop: '25px', padding: '75px 0 50px 0', background: 'rgba(0,0,0,0.01)' }}>
                                    <Col xs={22} lg={16}>
                                          {!forgotMode
                                                ? (
                                                      <Form
                                                            name="login"
                                                            layout="vertical"
                                                            initialValues={{ remember: true }}
                                                            onFinish={onFinish}
                                                            onFinishFailed={onFinishFailed}
                                                      >
                                                            <Form.Item
                                                                  label="Email"
                                                                  name="email"
                                                                  rules={[
                                                                        { required: true, message: 'Please input your email!' }
                                                                  ]}
                                                            >
                                                                  <Input />
                                                            </Form.Item>

                                                            <Form.Item
                                                                  label="Password"
                                                                  name="password"
                                                                  rules={[
                                                                        { required: true, message: 'Please input your password!' }
                                                                  ]}
                                                            >
                                                                  <Input.Password />
                                                            </Form.Item>

                                                            <Form.Item>
                                                                  <Button type="primary" htmlType="submit" loading={loading}>
                                                                        {btnText}
                                                                  </Button>
                                                            </Form.Item>
                                                            <p
                                                                  style={{ cursor: "pointer", color: "#E41882", fontStyle: "italic", marginTop: "10px" }}
                                                                  onClick={() => setForgotMode(true)}
                                                            >
                                                                  Forgot your password?
                                                            </p>
                                                      </Form>
                                                ) : (
                                                      <Form
                                                            name="forgot"
                                                            layout="vertical"
                                                            onFinish={onForgotFinish}
                                                      >
                                                            <Form.Item
                                                                  label="Email"
                                                                  name="email"
                                                                  rules={[
                                                                        { required: true, message: 'Please input your email!' }
                                                                  ]}
                                                            >
                                                                  <Input />
                                                            </Form.Item>

                                                            <Form.Item>
                                                                  <Button type="primary" htmlType="submit" loading={loading}>
                                                                        Send reset link
                                                                  </Button>
                                                            </Form.Item>

                                                            <p
                                                                  style={{ cursor: "pointer", color: "#E41882", fontStyle: "italic", marginTop: "10px" }}
                                                                  onClick={() => setForgotMode(false)}
                                                            >
                                                                  Return to login
                                                            </p>
                                                      </Form>
                                                )}
                                    </Col>
                              </Row>

                        </Col>

                  </Row>

            </>
      )

}
